import { EUserActions, UserActions } from '../actions/user.actions';
import { initialUserState, IUserState } from '../state/user.state';

export function userReducers(state = initialUserState, action: UserActions): IUserState {
    // export function userReducers = (state = initialUserState, action: UserActions): IUserState => {
    switch (action.type) {
        case EUserActions.LoginUser: {
            return {
                ...state
            };
        }
        case EUserActions.LoginUserSuccess: {
            return {
                ...state,
                userLoggedInInfo: action.payload,
                success: 'Successfully Loged in',
                userLoggedInError: null
            };
        }
        case EUserActions.LoginUserError: {
            return {
                ...state,
                userLoggedInError: action.payload,
                userLoggedInInfo: null
                
            };
        }

        case EUserActions.SendLinkForForgotPswdSuccess: {
            return {
                ...state,
                sendLinkForgotPswdSuccess: action.payload,
                sendLinkForgotPswdError: null
            };
        }
        case EUserActions.SendLinkForForgotPswdError: {
            return {
                ...state,
                sendLinkForgotPswdError: action.payload,
                sendLinkForgotPswdSuccess: null
            };
        }
        case EUserActions.ResetPasswordSuccess: {
            return {
                ...state,
                resetPasswordSuccess: action.payload,
                resetPasswordError: null
            };
        }
        case EUserActions.ResetPasswordError: {
            return {
                ...state,
                resetPasswordError: action.payload,
                resetPasswordSuccess: null
            };
        }
        case EUserActions.UpdateTermsSucces: {
            return {
                ...state,
                updateTermsSuccess: action.payload,
                updateTermsError: null
            }
        }
        case EUserActions.UpdateTermsError: {
            return {
                ...state,
                updateTermsError: action.payload,
                updateTermsSuccess: null
            }
        }
        case EUserActions.CheckPswdLinkSuccess: {
            return {
                ...state,
                checkResetPswdLinkSuccess: action.payload,
                checkResetPswdLinkError: null
            }
        }
        case EUserActions.CheckPswdLinkError: {
            return {
                ...state,
                checkResetPswdLinkError: action.payload,
                checkResetPswdLinkSuccess: null
            }
        }
        case EUserActions.ResetPasswordByLinkSuccess: {
            return {
                ...state,
                resetPswdByLinkSuccess: action.payload,
                resetPswdByLinkError: null
            }
        }
        case EUserActions.ResetPasswordByLinkError: {
            return {
                ...state,
                resetPswdByLinkError: action.payload,
                resetPswdByLinkSuccess: null
            }
        }
//         case EUserActions.GetAdminDetailsSuccess: {
//             console.log(action.payload)
//             return {
//                 ...state,
//                 admindetails: action.payload
//             };
//         }
        default:
            return state;
    }
}

